/**
 * Created by Administrador on 10/3/2016.
 */
(function() {
    'use strict';

    angular.module('completeAir')
        .factory('Util', UtilService);

    UtilService.$inject = ['$window'];

    function UtilService($window) {
        var Util = {

            safeCb: safeCb,
            urlParse: urlParse,
            isSameOrigin: isSameOrigin,
            isANumber: isANumber,
            removeCharacter: removeCharacter,
            stringToBoolean: stringToBoolean
        };

        return Util;

        function safeCb(cb){
            return angular.isFunction(cb) ? cb : angular.noop;
        }

        function urlParse(url){
            var a = document.createElement('a');
            a.href = url;

            if (a.host === '') {
                a.href = a.href;
            }

            return a;
        }

        function isSameOrigin(url, origins) {
            url = Util.urlParse(url);
            origins = origins && [].concat(origins) || [];
            origins = origins.map(Util.urlParse);
            origins.push($window.location);
            origins = origins.filter(function(o) {
                var hostnameCheck = url.hostname === o.hostname;//let
                var protocolCheck = url.protocol === o.protocol;//let
                var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url
                        .port === '443');//let
                return hostnameCheck && protocolCheck && portCheck;
            });
            return origins.length >= 1;
        }

        function isANumber(strNumber) {
            var k = strNumber.indexOf(".");

            if (k<0) {
                return isWholeNumber(strNumber);
            } else {
                if(k === (strNumber.length-1)){
                    return true;
                }else{
                    return (isWholeNumber(strNumber.substring(0,k)) && isWholeNumber(strNumber.substring(k+1)));
                }
            }
        }

        function isWholeNumber(strNumber) {
            var k = parseInt(strNumber,10);
            if (!isNaN(k)) {
                var char = "" + k;
                if (char === clearValue(strNumber,"0","0")) return true;
            }
            return false;
        }

        function clearValue(strNumber, value, returnValue) {
            var strNumberAux = strNumber;
            for (var i=0; i<strNumber.length;i++) {
                if (strNumber.substring(i,i+1) !== value) {
                    return strNumberAux;
                } else {
                    strNumberAux = strNumber.substring(i+1);
                }
            }
            if (strNumberAux.length === 0) strNumberAux = returnValue;
            return strNumberAux;
        }

        function removeCharacter(str, char_pos)
        {
            var part1 = str.substring(0, char_pos);
            var part2 = str.substring(char_pos + 1, str.length);
            return (part1 + part2);
        }

        function stringToBoolean(str)
        {
            return str === 'true';
        }
    }
})();
